/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';

import ButtonsUseStyles from 'consts/styles/Buttons';
import RequiredField from 'components/common/components/RequiredField';
import { addAlert } from 'store/actions/alert/alerts';
import { authPostRequest } from 'helpers/apiRequests';
import { formStyles } from 'consts/styles/Form';
import { userStyles } from 'consts/styles/User';
import { validateCheck } from 'components/user/admin/organizations/components/Helpers';

const ContactPage = () => {
  const formClasses = formStyles();
  const classesUser = userStyles();
  const classesButtons = ButtonsUseStyles();

  const dispatch = useDispatch();
  const [values, setValues] = React.useState({
    topic: '',
    description: '',
  });
  const [errors, setErrors] = React.useState({
    topic: true,
    description: true,
  });

  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const [subtitles] = React.useState(useString().contactModule);
  const [alertsSubtitles] = React.useState(useString().alerts);
  const [errorsSubtitles] = React.useState(useString().areas.placeholderForm);

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;

    setValues({
      ...values,
      [name]: value,
    });
    if (!validateCheck(name, value))
      setErrors({
        ...errors,
        [name]: true,
      });
    else
      setErrors({
        ...errors,
        [name]: false,
      });
  };

  const isDataValid = () => {
    let isValid = true;
    Object.keys(errors).forEach(key => {
      if (errors[key]) isValid = false;
    });
    if (!isValid) return false;
    return true;
  };

  const send = () => {
    if (!isDataValid()) return;

    const data = values;

    authPostRequest('message', data).then(result => {
      if (result.status === 201)
        dispatch(
          addAlert({
            title: alertsSubtitles.addDataSuccess.title_,
            desc: alertsSubtitles.addDataSuccess.desc_,
            type: 'success',
          })
        );
      else
        dispatch(
          addAlert({
            title: alertsSubtitles[result.data.code].title_,
            desc: alertsSubtitles[result.data.code].desc_,
            type: 'error',
          })
        );
    });
  };

  return (
    <Container className={`${classesUser.User}__wrapper__content__container`}>
      <Typography
        variant="h2"
        className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field__title`}
      >
        {subtitles.subHeader_}
      </Typography>
      <div>
        <form
          className={`${classesUser.User}__wrapper__content__form-container__form`}
          noValidate
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.topic,
                })}
                htmlFor="topic"
              >
                {subtitles.formFields.topic_}*
              </label>
              <TextField
                variant="outlined"
                required
                fullWidth
                error={errors.topic}
                id="topic"
                name="topic"
                autoComplete="topic"
                onChange={handleChange}
                value={values.title}
                helperText={
                  errors.topic
                    ? `${errorsSubtitles.required}${errorsSubtitles.text}`
                    : ''
                }
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                FormHelperTextProps={{
                  classes: {
                    error: `${formClasses.Form}__text-field__form-helper--error`,
                  },
                }}
                size="small"
              />
            </Grid>

            <Grid item xs={12}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.description,
                })}
                htmlFor="description"
              >
                {subtitles.formFields.desc_}*
              </label>
              <TextField
                variant="outlined"
                required
                rows="10"
                multiline
                error={errors.description}
                fullWidth
                id="description"
                name="description"
                autoComplete="description"
                onChange={handleChange}
                value={values.description}
                helperText={
                  errors.description
                    ? `${errorsSubtitles.required}${errorsSubtitles.description}`
                    : ''
                }
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                FormHelperTextProps={{
                  classes: {
                    error: `${formClasses.Form}__text-field__form-helper--error`,
                  },
                }}
                size="small"
              />
            </Grid>
          </Grid>

          <Button
            type="button"
            fullWidth
            onClick={send}
            className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
          >
            {subtitles.formFields.button_}
          </Button>
        </form>
        <RequiredField />
      </div>
    </Container>
  );
};

const ExportedContactPage = React.forwardRef((props, ref) => (
  <ContactPage {...props} {...ref} />
));
export default ExportedContactPage;
